class ProvinciaService {
  getProvincias() {
    return [
      {
        id: 1,
        nombre: "AZUAY",
        cantones: [
          { id: 1, nombre: "CUENCA" },
          { id: 2, nombre: "GIRÓN" },
          { id: 3, nombre: "GUALACEO" },
          { id: 4, nombre: "NABÓN" },
          { id: 5, nombre: "PAUTE" },
          { id: 6, nombre: "PUCARA" },
          { id: 7, nombre: "SAN FERNANDO" },
          { id: 8, nombre: "SANTA ISABEL" },
          { id: 9, nombre: "SIGSIG" },
          { id: 10, nombre: "OÑA" },
          { id: 11, nombre: "CHORDELEG" },
          { id: 12, nombre: "EL PAN" },
          { id: 13, nombre: "SEVILLA DE ORO" },
          { id: 14, nombre: "GUACHAPALA" },
          { id: 15, nombre: "CAMILO PONCE ENRÍQUEZ" }
        ]
      },
      {
        id: 2,
        nombre: "BOLIVAR",
        cantones: [
          { id: 16, nombre: "GUARANDA" },
          { id: 17, nombre: "CHILLANES" },
          { id: 18, nombre: "CHIMBO" },
          { id: 19, nombre: "ECHEANDÍA" },
          { id: 20, nombre: "SAN MIGUEL" },
          { id: 21, nombre: "CALUMA" },
          { id: 22, nombre: "LAS NAVES" }
        ]
      },
      {
        id: 3,
        nombre: "CAÑAR",
        cantones: [
          { id: 23, nombre: "AZOGUES" },
          { id: 24, nombre: "BIBLIÁN" },
          { id: 25, nombre: "CAÑAR" },
          { id: 26, nombre: "LA TRONCAL" },
          { id: 27, nombre: "EL TAMBO" },
          { id: 28, nombre: "DÉLEG" },
          { id: 29, nombre: "SUSCAL" }
        ]
      },
      {
        id: 4,
        nombre: "CARCHI",
        cantones: [
          { id: 30, nombre: "TULCÁN" },
          { id: 31, nombre: "BOLÍVAR" },
          { id: 32, nombre: "ESPEJO" },
          { id: 33, nombre: "MIRA" },
          { id: 34, nombre: "MONTÚFAR" },
          { id: 35, nombre: "SAN PEDRO DE HUACA" }
        ]
      },
      {
        id: 5,
        nombre: "COTOPAXI",
        cantones: [
          { id: 36, nombre: "LATACUNGA" },
          { id: 37, nombre: "LA MANÁ" },
          { id: 38, nombre: "PANGUA" },
          { id: 39, nombre: "PUJILI" },
          { id: 40, nombre: "SALCEDO" },
          { id: 41, nombre: "SAQUISILÍ" },
          { id: 42, nombre: "SIGCHOS" }
        ]
      },
      {
        id: 6,
        nombre: "CHIMBORAZO",
        cantones: [
          { id: 43, nombre: "RIOBAMBA" },
          { id: 44, nombre: "ALAUSI" },
          { id: 45, nombre: "COLTA" },
          { id: 46, nombre: "CHAMBO" },
          { id: 47, nombre: "CHUNCHI" },
          { id: 48, nombre: "GUAMOTE" },
          { id: 49, nombre: "GUANO" },
          { id: 50, nombre: "PALLATANGA" },
          { id: 51, nombre: "PENIPE" },
          { id: 52, nombre: "CUMANDÁ" }
        ]
      },
      {
        id: 7,
        nombre: "EL ORO",
        cantones: [
          { id: 53, nombre: "MACHALA" },
          { id: 54, nombre: "ARENILLAS" },
          { id: 55, nombre: "ATAHUALPA" },
          { id: 56, nombre: "BALSAS" },
          { id: 57, nombre: "CHILLA" },
          { id: 58, nombre: "EL GUABO" },
          { id: 59, nombre: "HUAQUILLAS" },
          { id: 60, nombre: "MARCABELÍ" },
          { id: 61, nombre: "PASAJE" },
          { id: 62, nombre: "PIÑAS" },
          { id: 63, nombre: "PORTOVELO" },
          { id: 64, nombre: "SANTA ROSA" },
          { id: 65, nombre: "ZARUMA" },
          { id: 66, nombre: "LAS LAJAS" }
        ]
      },
      {
        id: 8,
        nombre: "ESMERALDAS",
        cantones: [
          { id: 67, nombre: "ESMERALDAS" },
          { id: 68, nombre: "ELOY ALFARO" },
          { id: 69, nombre: "MUISNE" },
          { id: 70, nombre: "QUININDÉ" },
          { id: 71, nombre: "SAN LORENZO" },
          { id: 72, nombre: "ATACAMES" },
          { id: 73, nombre: "RIOVERDE" },
          { id: 74, nombre: "LA CONCORDIA" }
        ]
      },
      {
        id: 9,
        nombre: "GUAYAS",
        cantones: [
          { id: 75, nombre: "GUAYAQUIL" },
          { id: 76, nombre: "ALFREDO BAQUERIZO MORENO (JUJÁN)" },
          { id: 77, nombre: "BALAO" },
          { id: 78, nombre: "BALZAR" },
          { id: 79, nombre: "COLIMES" },
          { id: 80, nombre: "DAULE" },
          { id: 81, nombre: "DURÁN" },
          { id: 82, nombre: "EL EMPALME" },
          { id: 83, nombre: "EL TRIUNFO" },
          { id: 84, nombre: "MILAGRO" },
          { id: 85, nombre: "NARANJAL" },
          { id: 86, nombre: "NARANJITO" },
          { id: 87, nombre: "PALESTINA" },
          { id: 88, nombre: "PEDRO CARBO" },
          { id: 89, nombre: "SAMBORONDÓN" },
          { id: 90, nombre: "SANTA LUCÍA" },
          { id: 91, nombre: "SALITRE (URBINA JADO)" },
          { id: 92, nombre: "SAN JACINTO DE YAGUACHI" },
          { id: 93, nombre: "PLAYAS" },
          { id: 94, nombre: "SIMÓN BOLÍVAR" },
          { id: 95, nombre: "CORONEL MARCELINO MARIDUEÑA" },
          { id: 96, nombre: "LOMAS DE SARGENTILLO" },
          { id: 97, nombre: "NOBOL" },
          { id: 98, nombre: "GENERAL ANTONIO ELIZALDE" },
          { id: 99, nombre: "ISIDRO AYORA" }
        ]
      },
      {
        id: 10,
        nombre: "IMBABURA",
        cantones: [
          { id: 100, nombre: "IBARRA" },
          { id: 101, nombre: "ANTONIO ANTE" },
          { id: 102, nombre: "COTACACHI" },
          { id: 103, nombre: "OTAVALO" },
          { id: 104, nombre: "PIMAMPIRO" },
          { id: 105, nombre: "SAN MIGUEL DE URCUQUÍ" }
        ]
      },
      {
        id: 11,
        nombre: "LOJA",
        cantones: [
          { id: 106, nombre: "LOJA" },
          { id: 107, nombre: "CALVAS" },
          { id: 108, nombre: "CATAMAYO" },
          { id: 109, nombre: "CELICA" },
          { id: 110, nombre: "CHAGUARPAMBA" },
          { id: 111, nombre: "ESPÍNDOLA" },
          { id: 112, nombre: "GONZANAMÁ" },
          { id: 113, nombre: "MACARÁ" },
          { id: 114, nombre: "PALTAS" },
          { id: 115, nombre: "PUYANGO" },
          { id: 116, nombre: "SARAGURO" },
          { id: 117, nombre: "SOZORANGA" },
          { id: 118, nombre: "ZAPOTILLO" },
          { id: 119, nombre: "PINDAL" },
          { id: 120, nombre: "QUILANGA" },
          { id: 121, nombre: "OLMEDO" }
        ]
      },
      {
        id: 12,
        nombre: "LOS RIOS",
        cantones: [
          { id: 122, nombre: "BABAHOYO" },
          { id: 123, nombre: "BABA" },
          { id: 124, nombre: "MONTALVO" },
          { id: 125, nombre: "PUEBLOVIEJO" },
          { id: 126, nombre: "QUEVEDO" },
          { id: 127, nombre: "URDANETA" },
          { id: 128, nombre: "VENTANAS" },
          { id: 129, nombre: "VÍNCES" },
          { id: 130, nombre: "PALENQUE" },
          { id: 131, nombre: "BUENA FÉ" },
          { id: 132, nombre: "VALENCIA" },
          { id: 133, nombre: "MOCACHE" },
          { id: 134, nombre: "QUINSALOMA" }
        ]
      },
      {
        id: 13,
        nombre: "MANABI",
        cantones: [
          { id: 135, nombre: "PORTOVIEJO" },
          { id: 136, nombre: "BOLÍVAR" },
          { id: 137, nombre: "CHONE" },
          { id: 138, nombre: "EL CARMEN" },
          { id: 139, nombre: "FLAVIO ALFARO" },
          { id: 140, nombre: "JIPIJAPA" },
          { id: 141, nombre: "JUNÍN" },
          { id: 142, nombre: "MANTA" },
          { id: 143, nombre: "MONTECRISTI" },
          { id: 144, nombre: "PAJÁN" },
          { id: 145, nombre: "PICHINCHA" },
          { id: 146, nombre: "ROCAFUERTE" },
          { id: 147, nombre: "SANTA ANA" },
          { id: 148, nombre: "SUCRE" },
          { id: 149, nombre: "TOSAGUA" },
          { id: 150, nombre: "24 DE MAYO" },
          { id: 151, nombre: "PEDERNALES" },
          { id: 152, nombre: "OLMEDO" },
          { id: 153, nombre: "PUERTO LÓPEZ" },
          { id: 154, nombre: "JAMA" },
          { id: 155, nombre: "JARAMIJÓ" },
          { id: 156, nombre: "SAN VICENTE" }
        ]
      },
      {
        id: 14,
        nombre: "MORONA SANTIAGO",
        cantones: [
          { id: 157, nombre: "MORONA" },
          { id: 158, nombre: "GUALAQUIZA" },
          { id: 159, nombre: "LIMÓN INDANZA" },
          { id: 160, nombre: "PALORA" },
          { id: 161, nombre: "SANTIAGO" },
          { id: 162, nombre: "SUCÚA" },
          { id: 163, nombre: "HUAMBOYA" },
          { id: 164, nombre: "SAN JUAN BOSCO" },
          { id: 165, nombre: "TAISHA" },
          { id: 166, nombre: "LOGROÑO" },
          { id: 167, nombre: "PABLO SEXTO" },
          { id: 168, nombre: "TIWINTZA" }
        ]
      },
      {
        id: 15,
        nombre: "NAPO",
        cantones: [
          { id: 169, nombre: "TENA" },
          { id: 170, nombre: "ARCHIDONA" },
          { id: 171, nombre: "EL CHACO" },
          { id: 172, nombre: "QUIJOS" },
          { id: 173, nombre: "CARLOS JULIO AROSEMENA TOLA" }
        ]
      },
      {
        id: 16,
        nombre: "PASTAZA",
        cantones: [
          { id: 174, nombre: "PASTAZA" },
          { id: 175, nombre: "MERA" },
          { id: 176, nombre: "SANTA CLARA" },
          { id: 177, nombre: "ARAJUNO" }
        ]
      },
      {
        id: 17,
        nombre: "PICHINCHA",
        cantones: [
          { id: 178, nombre: "QUITO" },
          { id: 179, nombre: "CAYAMBE" },
          { id: 180, nombre: "MEJIA" },
          { id: 181, nombre: "PEDRO MONCAYO" },
          { id: 182, nombre: "RUMIÑAHUI" },
          { id: 183, nombre: "SAN MIGUEL DE LOS BANCOS" },
          { id: 184, nombre: "PEDRO VICENTE MALDONADO" },
          { id: 185, nombre: "PUERTO QUITO" }
        ]
      },
      {
        id: 18,
        nombre: "TUNGURAHUA",
        cantones: [
          { id: 186, nombre: "AMBATO" },
          { id: 187, nombre: "BAÑOS DE AGUA SANTA" },
          { id: 188, nombre: "CEVALLOS" },
          { id: 189, nombre: "MOCHA" },
          { id: 190, nombre: "PATATE" },
          { id: 191, nombre: "QUERO" },
          { id: 192, nombre: "SAN PEDRO DE PELILEO" },
          { id: 193, nombre: "SANTIAGO DE PÍLLARO" },
          { id: 194, nombre: "TISALEO" }
        ]
      },
      {
        id: 19,
        nombre: "ZAMORA CHINCHIPE",
        cantones: [
          { id: 195, nombre: "ZAMORA" },
          { id: 196, nombre: "CHINCHIPE" },
          { id: 197, nombre: "NANGARITZA" },
          { id: 198, nombre: "YACUAMBI" },
          { id: 199, nombre: "YANTZAZA (YANZATZA)" },
          { id: 200, nombre: "EL PANGUI" },
          { id: 201, nombre: "CENTINELA DEL CÓNDOR" },
          { id: 202, nombre: "PALANDA" },
          { id: 203, nombre: "PAQUISHA" }
        ]
      },
      {
        id: 20,
        nombre: "GALAPAGOS",
        cantones: [
          { id: 204, nombre: "SAN CRISTÓBAL" },
          { id: 205, nombre: "ISABELA" },
          { id: 206, nombre: "SANTA CRUZ" }
        ]
      },
      {
        id: 21,
        nombre: "SUCUMBIOS",
        cantones: [
          { id: 207, nombre: "LAGO AGRIO" },
          { id: 208, nombre: "GONZALO PIZARRO" },
          { id: 209, nombre: "PUTUMAYO" },
          { id: 210, nombre: "SHUSHUFINDI" },
          { id: 211, nombre: "SUCUMBÍOS" },
          { id: 212, nombre: "CASCALES" },
          { id: 213, nombre: "CUYABENO" }
        ]
      },
      {
        id: 22,
        nombre: "ORELLANA",
        cantones: [
          { id: 214, nombre: "ORELLANA" },
          { id: 215, nombre: "AGUARICO" },
          { id: 216, nombre: "LA JOYA DE LOS SACHAS" },
          { id: 217, nombre: "LORETO" }
        ]
      },
      {
        id: 23,
        nombre: "SANTO DOMINGO DE LOS TSACHILAS",
        cantones: [{ id: 218, nombre: "SANTO DOMINGO" }]
      },
      {
        id: 24,
        nombre: "SANTA ELENA",
        cantones: [
          { id: 219, nombre: "SANTA ELENA" },
          { id: 220, nombre: "LA LIBERTAD" },
          { id: 221, nombre: "SALINAS" }
        ]
      }
    ];
  }
}

export default new ProvinciaService();
